import React from 'react';
import classnames from 'classnames';
import { useDraggable } from '@dnd-kit/core';

import Icon from 'components/Misc/Icon';
import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import { useBlankCourseStore } from 'store/blank/useBlankCourseStore';

const Draggable = ({ course }) => {
	// Use blank's creation store
	const onRemoveCourse = useBlankCourseStore(state => state.onRemoveCourse);

	// Create draggable element
	const { attributes, listeners, isDragging, setNodeRef } = useDraggable({
		id: course.id
	});

	// Create classnames
	const cls = classnames(
		'py-2 px-3 flex items-center space-x-2 border border-neutral-200 dark:border-neutral-700 rounded-lg transition-colors',
		isDragging && 'opacity-70'
	);

	// Handle course removal
	const onRemove = () => onRemoveCourse(course.id);

	return (
		<div ref={setNodeRef} className={cls}>
			<div {...attributes} {...listeners}>
				<Icon
					icon="drag_indicator"
					className="text-neutral-800 dark:text-white cursor-move transition-colors"
				/>
			</div>

			<Title
				title={course.title}
				subtitle={course.subject?.title}
				className="flex-1"
			/>

			<Button
				small
				square
				icon="link"
				to={`/courses/${course.id}`}
			/>

			<Button
				small
				square
				icon="close"
				theme="danger"
				onClick={onRemove}
			/>
		</div>
	);
};

export default Draggable;